export enum KnowledgeType {
  FAQ = 1,
  CONVERSATION = 2,
  DOCUMENT = 3,
  SOP = 4,
  INTENT = 5,
}
